import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CiscoUiModule } from '../cisco-ui/cisco-ui.module';

import { DialogsService } from './dialogs.service';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    CiscoUiModule,
  ],
  declarations: [
    InfoDialogComponent,
    ConfirmationDialogComponent,
  ],
  entryComponents: [
    InfoDialogComponent,
    ConfirmationDialogComponent,
  ],
  providers: [
    DialogsService,
  ]
})
export class DialogsModule { }
